function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckcircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1021.75 12 9.761 9.761 0 0012 2.25zm4.644 8.043l-5.5 5.25a.752.752 0 01-1.038 0l-2.75-2.625a.75.75 0 011.038-1.086l2.23 2.13 4.982-4.755a.75.75 0 011.038 1.086z",
    fill: props.fill
  }));
}

export default SvgCheckcircle;